import { IRLinkAPI } from "../types";

/**
 * @Doc Implementation for the `RLinkAPI` interface operating in mode `wait`
 *
 * This class provides an implementation of the `IRLinkAPI` with the following behavior:
 * - Does not trigger automatic rendering.
 * - Exposes `render` method for manual rendering via `getAPIPayload`.
 *
 * API Usage Example:
 * ```html
 * <!-- Include the Readership Link script in your HTML -->
 * <script src="https://cdn.btmessage.com/rlink.js"></script>
 *
 * <script>
 * // Listen to the event indicating the Readership Link script was loaded and the render criteria were met.
 * // Use { once: true } to ensure the listener is automatically removed after first trigger.
 * // This event is dispatched multiple times to avoid race conditions.
 * // The listener can be added before or after the Readership Link script is loaded.
 * window.addEventListener('bt-rlink-api-ready', function(event) {
 *     // After the step above, the API can be called anytime
 *     const api = event.detail.api();
 *     // Manually trigger rendering
 *     api.render();
 * }, { once: true });
 * </script>
 * ```
 * */
export class WaitModeAPI implements IRLinkAPI {
  /**
   * @param render - The callback function to invoke when rendering.
   */
  constructor(private render: () => void) {}

  start() {}

  /**
   * Retrieves the payload containing methods for controlling rendering behavior.
   *
   * The payload includes:
   * - `render`: Manually triggers the rendering callback.
   *
   * @returns RLinkAPIWaitModePayload - The API payload for controlling rendering.
   */
  getAPIPayload() {
    return {
      render: () => {
        this.render();
      },
    };
  }
}
